"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableDraggableContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.TableDraggableContext = react_1.default.createContext({
    isDragging: false,
    placeholder: null,
});
//# sourceMappingURL=TableDraggableContext.js.map